/**
 * Conteúdo antigo em texto puro vira parágrafos na leitura (#412, D8).
 *
 * Os textos semeados já são HTML, mas o campo de conteúdo era uma caixa de
 * texto pura — pode haver texto escrito com quebras de linha e nenhuma tag. Sem
 * esta conversão o editor abriria tudo num parágrafo só, e a primeira gravação
 * perderia as quebras de verdade. A conversão é na leitura: nada é reescrito no
 * banco.
 *
 * A marcação inline que já esteja no texto (`<strong>`) e as chaves do template
 * (`{{empresa.razaoSocial}}`) passam intactas — o que se decide aqui é só onde
 * cada parágrafo começa.
 */

/** Uma tag de bloco basta para tratar o conteúdo como HTML já formatado. */
const TAG_DE_BLOCO =
  /<(p|div|h[1-6]|ul|ol|li|table|thead|tbody|tfoot|tr|td|th|blockquote|pre|section|article|figure|hr)\b/i;

export const htmlDeTextoLegado = (conteudo: string): string => {
  if (TAG_DE_BLOCO.test(conteudo)) return conteudo;

  return conteudo
    .split(/\n\s*\n/)
    .map((paragrafo) => paragrafo.trim())
    .filter((paragrafo) => paragrafo !== '')
    .map((paragrafo) => `<p>${paragrafo.split('\n').join('<br>')}</p>`)
    .join('');
};

export default htmlDeTextoLegado;
